//@flow
import * as React from 'react'
import Paper from 'material-ui/Paper'
import type { MaterialPaperWrap$Props } from './flowTypes'

const MaterialPaperWrap=(props:MaterialPaperWrap$Props)=>{
    return (
        <Paper>
            {props.children}
        </Paper>
    )
}

export default MaterialPaperWrap


// WEBPACK FOOTER //
// ./src/components/common/MaterialPaperWrap.js